export const CATALOG_MODE_FIELD = 'catalog_mode' as const;
export const CATALOG_MODES = ['AI', 'PE'] as const;

export type CatalogMode = (typeof CATALOG_MODES)[number];

const AI_ALIASES = new Set(['AI', 'AUTUNNOINVERNO', 'AW', 'FW', 'FALLWINTER']);
const PE_ALIASES = new Set(['PE', 'PRIMAVERAESTATE', 'SS', 'SPRINGSUMMER']);

function compactModeToken(value: string): string {
  return value.trim().toUpperCase().replace(/[\s/_-]+/g, '');
}

export function isCatalogMode(value: unknown): value is CatalogMode {
  return typeof value === 'string' && CATALOG_MODES.includes(value as CatalogMode);
}

export function normalizeCatalogMode(value: unknown): CatalogMode | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }

  const compact = compactModeToken(value);
  if (!compact) {
    return undefined;
  }

  if (AI_ALIASES.has(compact)) {
    return 'AI';
  }

  if (PE_ALIASES.has(compact)) {
    return 'PE';
  }

  return undefined;
}

export function getCatalogModeLabel(mode: CatalogMode | undefined): string {
  if (mode === 'PE') {
    return 'Primavera/Estate';
  }

  return 'Autunno/Inverno';
}

export function getCollectionFromCatalogMode(mode: CatalogMode | undefined): 'ai' | 'pe' | undefined {
  if (mode === 'AI') {
    return 'ai';
  }
  if (mode === 'PE') {
    return 'pe';
  }
  return undefined;
}
